<template>
    <v-layout justify-center>
        <v-responsive width="100%">
            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12" lg="">
                    <v-row class="ma-n2">
                        <v-col class="pa-2" cols="12">
                            <statistics-common-filter v-model="searchDateValue" v-bind="{ loading }" @input="updatedCount = 0" />
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <statistics-main-visits
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <statistics-main-current
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pa-2" cols="12" lg="auto" style="width: 480px; max-width: 100%">
                    <v-row class="ma-n2">
                        <v-col class="pa-2" cols="12">
                            <statistics-main-referrer
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" lg="6">
                            <statistics-main-users
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" lg="6">
                            <statistics-main-device
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" lg="6">
                            <statistics-main-browser
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12" lg="6">
                            <statistics-main-os
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";

import StatisticsCommonFilter from "@/components/console/statistics/common/statistics-common-filter.vue";
import StatisticsMainBrowser from "@/components/console/statistics/main/statistics-main-browser.vue";
import StatisticsMainCurrent from "@/components/console/statistics/main/statistics-main-current.vue";
import StatisticsMainDevice from "@/components/console/statistics/main/statistics-main-device.vue";
import StatisticsMainReferrer from "@/components/console/statistics/main/statistics-main-referrer.vue";
import StatisticsMainUsers from "@/components/console/statistics/main/statistics-main-users.vue";
import StatisticsMainVisits from "@/components/console/statistics/main/statistics-main-visits.vue";
import StatisticsMainOs from "@/components/console/statistics/main/statistics-main-os.vue";

export default {
    components: {
        StatisticsCommonFilter,
        StatisticsMainBrowser,
        StatisticsMainCurrent,
        StatisticsMainDevice,
        StatisticsMainReferrer,
        StatisticsMainUsers,
        StatisticsMainVisits,
        StatisticsMainOs,
    },

    data: () => ({
        searchDateValue: [
            //
            dayjs().subtract(1, "month").add(1, "day").startOf("day").toISOString(),
            dayjs().endOf("day").toISOString(),
        ],

        updatedCount: 0,
    }),
    computed: {
        loading() {
            return this.updatedCount < 7;
        },
    },
    methods: {
        updated() {
            this.updatedCount += 1;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    th,
    td {
        border-color: var(--v-content-base) !important;
    }
}
</style>